import type React from 'react';
import SvgMaskIcon from './SvgMaskIcon';

interface DashIconProps {
    width?: number;
    height?: number;
    color?: string;
    className?: string;
}

const INNER = '<path d="M4 10H16" stroke="#000" stroke-width="2" stroke-linecap="round"/>';

const DashIcon: React.FC<DashIconProps> = ({
    width = 20,
    height = 20,
    color = '#656565',
    className = '',
}) => (
    <SvgMaskIcon
        viewBox="0 0 20 20"
        inner={INNER}
        width={width}
        height={height}
        color={color}
        className={className}
    />
);

export default DashIcon;
